import { render, staticRenderFns } from "./GwRing.html?vue&type=template&id=2772ad0a&scoped=true&external"
import script from "./GwRing.vue?vue&type=script&lang=js"
export * from "./GwRing.vue?vue&type=script&lang=js"
import style0 from "./GwRing.scss?vue&type=style&index=0&id=2772ad0a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772ad0a",
  null
  
)

export default component.exports